(function () {
  function productString(key) {
    return ((window.Axiom && window.Axiom.productStrings && window.Axiom.productStrings[key]) || '').toString();
  }

  function setMotionButtonText(target, text) {
    if (!target) return;
    if (window.Axiom && typeof window.Axiom.setMotionLabel === 'function') {
      if (window.Axiom.setMotionLabel(target, text, 'button')) return;
    }
    target.textContent = text;
  }

  function cartString(key) {
    return ((window.Axiom && window.Axiom.cartStrings && window.Axiom.cartStrings[key]) || '').toString();
  }

  function sellingPlanIdFromForm(form) {
    var input = form && (form.querySelector('[data-selling-plan-input]') || form.querySelector('[name="selling_plan"]'));
    return input ? String(input.value || '').trim() : '';
  }

  function initAxiomProduct(root) {
    var scope = root && root.querySelector ? root : document;
    var sectionEl = scope && scope.matches && scope.matches('[data-product-root]')
      ? scope
      : scope.querySelector('[data-product-root]');
    if (!sectionEl) return;
    var sectionScope = sectionEl.closest('[id^="shopify-section-"]') || sectionEl;
    if (sectionEl.dataset && sectionEl.dataset.productInitialized === 'true') return;
    if (sectionEl.dataset) sectionEl.dataset.productInitialized = 'true';
    var cleanups = [];
    var atcFeedbackTimer = null;
    var stickyObs = null;
    var stickyResizeObserver = null;

    function on(target, eventName, handler, options) {
      if (!target || typeof target.addEventListener !== 'function') return;
      target.addEventListener(eventName, handler, options);
      cleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function queryInRoot(selector) {
      return sectionEl.querySelector(selector);
    }

    function queryAllInRoot(selector) {
      return Array.prototype.slice.call(sectionEl.querySelectorAll(selector));
    }

    function queryInSection(selector) {
      return sectionScope.querySelector(selector);
    }

    function queryAllInSection(selector) {
      return Array.prototype.slice.call(sectionScope.querySelectorAll(selector));
    }

    function queryById(scopeNode, id) {
      if (!scopeNode) return null;
      return scopeNode.querySelector('#' + id);
    }

    function portalStickyAtc(stickyAtc) {
      if (!stickyAtc || stickyAtc.parentNode === document.body) return;
      // Footer reveal transforms #main-content; fixed children there become section-bound.
      document.body.appendChild(stickyAtc);
    }

    function portalFixedOverlay(overlay) {
      if (!overlay || overlay.parentNode === document.body) return;
      // Smooth-scroll transforms create containing blocks for fixed overlays.
      document.body.appendChild(overlay);
    }

    function getFormSubmitter(event) {
      if (event && event.submitter) return event.submitter;
      return document.activeElement && document.activeElement.closest
        ? document.activeElement.closest('button, input[type="submit"]')
        : null;
    }

  // ── PRODUCT DATA ──────────────────────────────
  var productJsonEl = queryInSection('[id^="product-json-"]');
  var productData = null;
  try { if (productJsonEl) productData = JSON.parse(productJsonEl.textContent); } catch(e) {}
  var productConfigEl = queryInSection('[data-product-config]');
  var productSectionConfig = {};
  try { if (productConfigEl) productSectionConfig = JSON.parse(productConfigEl.textContent); } catch(e) {}
  productSectionConfig = decodeConfigStrings(productSectionConfig);
  var productB2BConfigEl = queryInSection('[data-product-b2b-config]');
  var productB2BConfig = {};
  try { if (productB2BConfigEl) productB2BConfig = JSON.parse(productB2BConfigEl.textContent); } catch(e) {}
  var highVariantState = window.AxiomHighVariantPicker && window.AxiomHighVariantPicker.read(sectionScope);
  var highVariantProduct = window.AxiomHighVariantPicker && window.AxiomHighVariantPicker.isHighVariant(highVariantState);
  var selectedHighVariant = highVariantProduct ? highVariantState.variant : null;
  var highVariantRequest = null;
  if (highVariantProduct && selectedHighVariant && highVariantState.variantState) {
    productB2BConfig.variants = productB2BConfig.variants || {};
    productB2BConfig.variants[String(selectedHighVariant.id)] = highVariantState.variantState;
    if (productB2BConfigEl) productB2BConfigEl.textContent = JSON.stringify(productB2BConfig);
  }

  function decodeHtmlString(value) {
    if (typeof value !== 'string' || value.indexOf('&') === -1) return value;
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function decodeConfigStrings(config) {
    Object.keys(config || {}).forEach(function (key) {
      config[key] = decodeHtmlString(config[key]);
    });
    return config || {};
  }

  function motionDuration(name, fallback) {
    return window.Axiom && typeof window.Axiom.getMotionDuration === 'function'
      ? window.Axiom.getMotionDuration(name, fallback)
      : parseFloat(fallback) || 420;
  }

  function motionEase(name, fallback) {
    return window.Axiom && typeof window.Axiom.getMotionEase === 'function'
      ? window.Axiom.getMotionEase(name, fallback)
      : fallback;
  }

  function money(cents) {
    return window.Axiom.formatMoney(cents);
  }

  // ── MEDIA GALLERY ─────────────────────────────
  var mainWrap = queryById(sectionEl, 'mainImageWrap');
  var mediaGallery = queryInRoot('[data-media-gallery]');
  var mediaStage = queryInRoot('[data-media-stage]');
  var mediaItemEls = queryAllInRoot('[data-media-item]');
  var thumbBtns = queryAllInRoot('[data-thumb]');
  var prevThumbNavBtn = queryInRoot('[data-thumb-nav-prev]');
  var nextThumbNavBtn = queryInRoot('[data-thumb-nav-next]');
  var prevMediaBtn = queryInRoot('[data-media-prev]');
  var nextMediaBtn = queryInRoot('[data-media-next]');
  var splitShowcaseRows = queryAllInRoot('[data-split-showcase-row]');
  var splitRowPrevBtns = queryAllInRoot('[data-split-row-prev]');
  var splitRowNextBtns = queryAllInRoot('[data-split-row-next]');
  var isFeaturedStage = !!(mediaGallery && mediaGallery.classList.contains('media-gallery--featured_stage'));
  var isOneImageStack = !!(mediaGallery && mediaGallery.classList.contains('media-gallery--stacked_full_image'));
  var isTwoRows = !!(mediaGallery && mediaGallery.classList.contains('media-gallery--two_rows'));
  var isVerticalSplitImage = !!(mediaGallery && mediaGallery.classList.contains('media-gallery--vertical_split_image'));
  var canOpenLightbox = !!(mainWrap && mainWrap.dataset.zoomEnabled === 'true');
  var mediaItems = [];
  var currentIdx = Math.max(0, Array.prototype.findIndex.call(mediaItemEls, function (item) {
    return item.classList.contains('active');
  }));
  if (currentIdx < 0) currentIdx = 0;
  mediaItemEls.forEach(function (itemEl, index) {
    var mediaEl = itemEl.querySelector('.media-main');
    mediaItems.push({
      id: itemEl.dataset.mediaId || '',
      type: itemEl.dataset.mediaType || 'image',
      lightbox: itemEl.dataset.lightboxSrc || '',
      mediaEl: mediaEl
    });
    if (itemEl.classList.contains('active')) currentIdx = index;
  });

  // A single gallery controller owns active media, thumbnail state and page-scroll
  // synchronization for both stacked and vertical galleries. The callbacks keep
  // PDP-specific XR/media behavior outside of the shared controller.
  var galleryController = window.AxiomProductGalleryController && mediaGallery
    ? window.AxiomProductGalleryController.create(mediaGallery, {
        mediaSelector: '[data-media-item]',
        thumbSelector: '[data-thumb]',
        pauseMedia: function () { pauseProductMedia(mediaGallery); },
        isControlTarget: function (target) {
          return window.AxiomProductMedia && window.AxiomProductMedia.isControlTarget
            ? window.AxiomProductMedia.isControlTarget(target)
            : false;
        },
        onActiveChange: function (item, index) {
          currentIdx = index;
          if (mainWrap && item) mainWrap.dataset.currentMediaType = item.type;
          if (mediaGallery && window.AxiomProductMedia) {
            window.AxiomProductMedia.syncXrButton(mediaGallery, item && item.id);
            window.AxiomProductMedia.playAutoplay(item && item.element);
          }
        }
      })
    : null;
  if (galleryController) {
    mediaItems = galleryController.items;
    mediaItemEls = galleryController.mediaItems;
    thumbBtns = galleryController.allThumbBtns;
    currentIdx = galleryController.currentIdx;
  }

  function pauseProductMedia() {
    if (window.AxiomProductMedia) {
      window.AxiomProductMedia.pauseAll(mediaGallery || document);
    }
  }

  function setMedia(idx, options) {
    if (!mediaItems.length) return;
    options = options || {};
    if (!galleryController) return;
    var result = galleryController.setMedia(idx, options);
    if (result) currentIdx = result.index;
  }

  function setMediaById(mediaId, options) {
    if (!mediaId) return;
    options = options || {};
    var id = String(mediaId);
    var idx = mediaItems.findIndex(function (item) { return String(item.id) === id; });
    if (idx >= 0) {
      setMedia(idx, {
        scrollMedia: options.scrollMedia === true,
        scrollThumb: options.scrollThumb === true
      });
    }
  }

  function findImageMediaIndex(direction) {
    if (!mediaItems.length) return -1;
    var step = direction < 0 ? -1 : 1;
    for (var offset = 1; offset <= mediaItems.length; offset++) {
      var idx = (currentIdx + (offset * step) + mediaItems.length) % mediaItems.length;
      if (mediaItems[idx] && mediaItems[idx].type === 'image') return idx;
    }
    return -1;
  }

  function getLightboxPreviewSrc(item) {
    if (!item || item.type !== 'image' || !item.mediaEl) return '';
    return item.mediaEl.currentSrc || item.mediaEl.src || item.lightbox || '';
  }

  function getLightboxImageSrc(item) {
    if (!item || item.type !== 'image' || !item.mediaEl) return '';
    return item.lightbox || getLightboxPreviewSrc(item);
  }

  function getSplitRowStep(track) {
    if (!track) return 0;
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-media-item]'));
    if (items.length > 1) {
      return Math.max(items[1].offsetLeft - items[0].offsetLeft, items[0].getBoundingClientRect().width || 0);
    }
    return items[0] ? items[0].getBoundingClientRect().width || 0 : track.clientWidth;
  }

  function updateSplitRowNav(row) {
    if (!row) return;
    var track = row.querySelector('[data-split-showcase-track]');
    var prev = row.querySelector('[data-split-row-prev]');
    var next = row.querySelector('[data-split-row-next]');
    if (!track || (!prev && !next)) return;
    var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft >= maxScroll - 1;
    var isScrollable = maxScroll > 1;
    if (prev) {
      prev.classList.toggle('is-disabled', !isScrollable || atStart);
      prev.setAttribute('aria-disabled', String(!isScrollable || atStart));
    }
    if (next) {
      next.classList.toggle('is-disabled', !isScrollable || atEnd);
      next.setAttribute('aria-disabled', String(!isScrollable || atEnd));
    }
  }

  function updateSplitShowcaseNav() {
    splitShowcaseRows.forEach(updateSplitRowNav);
  }

  function scrollSplitShowcaseRow(button, direction) {
    var row = button.closest('[data-split-showcase-row]');
    var track = row ? row.querySelector('[data-split-showcase-track]') : null;
    if (!track) return;
    var step = getSplitRowStep(track);
    track.scrollBy({
      left: step * direction,
      behavior: 'smooth'
    });
    window.setTimeout(function () {
      updateSplitRowNav(row);
    }, 260);
  }

  if (prevMediaBtn) {
    prevMediaBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMedia(currentIdx - 1, { scrollMedia: true });
    });
  }
  if (nextMediaBtn) {
    nextMediaBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMedia(currentIdx + 1, { scrollMedia: true });
    });
  }
  if (prevThumbNavBtn) {
    prevThumbNavBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMedia(currentIdx - 1, { scrollMedia: true });
    });
  }
  if (nextThumbNavBtn) {
    nextThumbNavBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMedia(currentIdx + 1, { scrollMedia: true });
    });
  }
  splitRowPrevBtns.forEach(function (button) {
    on(button, 'click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      scrollSplitShowcaseRow(button, -1);
    });
  });
  splitRowNextBtns.forEach(function (button) {
    on(button, 'click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      scrollSplitShowcaseRow(button, 1);
    });
  });
  splitShowcaseRows.forEach(function (row) {
    var track = row.querySelector('[data-split-showcase-track]');
    if (track) on(track, 'scroll', function () { updateSplitRowNav(row); }, { passive: true });
  });
  if (splitShowcaseRows.length) {
    on(window, 'resize', updateSplitShowcaseNav);
    updateSplitShowcaseNav();
  }
  if (mediaItems.length) {
    setMedia(currentIdx, { scrollMedia: false });
    if ((isVerticalSplitImage || isOneImageStack) && galleryController) galleryController.syncFromScroll();
    updateSplitShowcaseNav();
  }

  // ── LIGHTBOX ──────────────────────────────────
  var lightbox = queryById(sectionScope, 'lightbox');
  portalFixedOverlay(lightbox);
  var lightboxImg = queryById(lightbox, 'lightboxImg');
  var lightboxFrame = lightbox && lightbox.querySelector('.lightbox-frame');
  var lightboxControls = lightbox && lightbox.querySelector('.lightbox-controls');
  if (lightbox && mainWrap && lightboxImg && lightboxFrame) {
    var lightboxAnimation = null;
    var lightboxClosing = false;
    var lightboxImageRequestId = 0;
    var lightboxDecodedSources = new Map();
    var lightboxHoverZoomEnabled = lightbox.dataset.hoverZoom === 'true';
    var lightboxHoverZoomQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    var configuredLightboxZoomScale = Number(lightbox.dataset.zoomScale) / 100;
    var lightboxZoomScale = Number.isFinite(configuredLightboxZoomScale)
      ? Math.min(5, Math.max(1.1, configuredLightboxZoomScale))
      : 2;
    lightbox.style.setProperty('--lightbox-zoom-scale', lightboxZoomScale);

    function canUseLightboxHoverZoom() {
      return lightboxHoverZoomEnabled && lightboxHoverZoomQuery.matches && lightbox.classList.contains('is-ready');
    }

    function updateLightboxZoomOrigin(event) {
      if (!canUseLightboxHoverZoom()) return;
      var left = parseFloat(lightboxImg.style.left);
      var top = parseFloat(lightboxImg.style.top);
      var width = parseFloat(lightboxImg.style.width);
      var height = parseFloat(lightboxImg.style.height);
      if (![left, top, width, height].every(Number.isFinite) || width <= 0 || height <= 0) return;
      var isInsideImage = event.clientX >= left
        && event.clientX <= left + width
        && event.clientY >= top
        && event.clientY <= top + height;
      if (!isInsideImage || (lightboxControls && lightboxControls.contains(event.target))) {
        resetLightboxZoom(false);
        return;
      }
      var originX = Math.min(100, Math.max(0, ((event.clientX - left) / width) * 100));
      var originY = Math.min(100, Math.max(0, ((event.clientY - top) / height) * 100));
      lightboxImg.style.transformOrigin = originX + '% ' + originY + '%';
      lightbox.classList.add('is-zoomed');
    }

    function resetLightboxZoom(immediate) {
      lightbox.classList.remove('is-zoomed');
      if (!immediate) return;
      lightboxImg.style.transformOrigin = '50% 50%';
      lightboxImg.style.transition = 'none';
      lightboxImg.style.transform = 'none';
      void lightboxImg.offsetWidth;
      lightboxImg.style.transition = '';
      lightboxImg.style.transform = '';
    }

    function getLightboxImageDimensions(item) {
      if (!item || !item.mediaEl) return { width: 0, height: 0, ratio: 1 };
      var width = Number(item.mediaEl.getAttribute('width')) || item.mediaEl.naturalWidth || 0;
      var height = Number(item.mediaEl.getAttribute('height')) || item.mediaEl.naturalHeight || 0;
      return {
        width: width,
        height: height,
        ratio: width > 0 && height > 0 ? width / height : 1
      };
    }

    function getLightboxTargetRect(imageRatio) {
      var viewportW = window.innerWidth;
      var viewportH = window.innerHeight;
      var maxW = viewportW * 0.92;
      var maxH = viewportH * 0.88;
      var ratio = Number.isFinite(imageRatio) && imageRatio > 0 ? imageRatio : 1;
      var width = maxW;
      var height = width / ratio;
      if (height > maxH) {
        height = maxH;
        width = height * ratio;
      }
      return {
        left: (viewportW - width) / 2,
        top: (viewportH - height) / 2,
        width: width,
        height: height
      };
    }

    function setLightboxRect(rect) {
      lightboxImg.style.left = rect.left + 'px';
      lightboxImg.style.top = rect.top + 'px';
      lightboxImg.style.width = rect.width + 'px';
      lightboxImg.style.height = rect.height + 'px';
    }

    function decodeLightboxSource(src) {
      if (!src) return Promise.resolve(null);
      if (lightboxDecodedSources.has(src)) return lightboxDecodedSources.get(src);

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
      var decodedSource = image.decode().then(function () {
        return src;
      }).catch(function () {
        return null;
      });
      lightboxDecodedSources.set(src, decodedSource);
      return decodedSource;
    }

    function setLightboxContent(item, displaySrc) {
      if (!displaySrc) return null;
      var dimensions = getLightboxImageDimensions(item);

      lightboxImg.removeAttribute('srcset');
      lightboxImg.removeAttribute('sizes');
      lightboxImg.src = displaySrc;
      lightboxImg.alt = item.mediaEl.alt || '';
      if (dimensions.width > 0 && dimensions.height > 0) {
        lightboxImg.width = Math.round(dimensions.width);
        lightboxImg.height = Math.round(dimensions.height);
      }

      return getLightboxTargetRect(dimensions.ratio);
    }

    function upgradeLightboxImage(item, requestId) {
      var previewSrc = getLightboxPreviewSrc(item);
      var lightboxSrc = getLightboxImageSrc(item);
      if (!lightboxSrc || lightboxSrc === previewSrc) return;

      decodeLightboxSource(lightboxSrc).then(function (decodedSrc) {
        if (!decodedSrc || requestId !== lightboxImageRequestId) return;
        if (lightbox.getAttribute('aria-hidden') !== 'false' || mediaItems[currentIdx] !== item) return;
        lightboxImg.src = decodedSrc;
      });
    }

    function preloadAdjacentLightboxPreviews() {
      [-1, 1].forEach(function (direction) {
        var idx = findImageMediaIndex(direction);
        if (idx < 0) return;
        decodeLightboxSource(getLightboxPreviewSrc(mediaItems[idx]));
      });
    }

    function getLightboxSourceElement() {
      if (isOneImageStack || isTwoRows || isVerticalSplitImage) {
        var activeItem = mediaItemEls[currentIdx];
        if (activeItem) {
          return activeItem.querySelector('.media-main') || activeItem;
        }
      }
      return mainWrap;
    }

    function openLightbox() {
      if (!canOpenLightbox) return;
      var item = mediaItems[currentIdx] || {};
      if (item.type !== 'image' || !item.mediaEl || lightboxClosing) return;
      var previewSrc = getLightboxPreviewSrc(item);
      if (!previewSrc) return;
      resetLightboxZoom(true);
      var requestId = ++lightboxImageRequestId;
      if (lightboxAnimation) {
        lightboxAnimation.cancel();
        lightboxAnimation = null;
      }

      decodeLightboxSource(previewSrc).then(function (decodedSrc) {
        if (!decodedSrc || requestId !== lightboxImageRequestId || lightboxClosing) return;
        var target = setLightboxContent(item, decodedSrc);
        if (!target) return;
        mainWrap.classList.add('is-lightbox-opening');
        lightbox.classList.remove('is-closing');
        var sourceEl = getLightboxSourceElement();
        var start = sourceEl.getBoundingClientRect();

        lightbox.classList.remove('is-ready');
        lightboxImg.style.left = start.left + 'px';
        lightboxImg.style.top = start.top + 'px';
        lightboxImg.style.width = start.width + 'px';
        lightboxImg.style.height = start.height + 'px';
        lightboxImg.style.opacity = '1';
        lightbox.setAttribute('aria-hidden', 'false');
        lightbox.removeAttribute('inert');
        window.Axiom.lockPageScroll(lightbox);
        preloadAdjacentLightboxPreviews();

        lightboxAnimation = lightboxImg.animate([
          {
            left: start.left + 'px',
            top: start.top + 'px',
            width: start.width + 'px',
            height: start.height + 'px'
          },
          {
            left: target.left + 'px',
            top: target.top + 'px',
            width: target.width + 'px',
            height: target.height + 'px'
          }
        ], {
          duration: motionDuration('--motion-duration', '420ms'),
          easing: motionEase('--motion-ease', 'cubic-bezier(0.22, 1, 0.36, 1)'),
          fill: 'forwards'
        });

        lightboxAnimation.onfinish = function () {
          setLightboxRect(target);
          lightbox.classList.add('is-ready');
          mainWrap.classList.remove('is-lightbox-opening');
          lightboxAnimation = null;
          upgradeLightboxImage(item, requestId);
        };
        lightboxAnimation.oncancel = function () {
          mainWrap.classList.remove('is-lightbox-opening');
          lightboxAnimation = null;
        };
      });
    }

    function navigateLightbox(direction) {
      var idx = findImageMediaIndex(direction);
      if (idx < 0) return;
      var item = mediaItems[idx];
      var previewSrc = getLightboxPreviewSrc(item);
      if (!previewSrc) return;
      resetLightboxZoom(true);
      var requestId = ++lightboxImageRequestId;

      decodeLightboxSource(previewSrc).then(function (decodedSrc) {
        if (!decodedSrc || requestId !== lightboxImageRequestId || lightboxClosing) return;
        var target = setLightboxContent(item, decodedSrc);
        if (!target) return;
        setMedia(idx, { scrollMedia: false });
        setLightboxRect(target);
        upgradeLightboxImage(item, requestId);
        preloadAdjacentLightboxPreviews();
      });
    }

    function resizeLightboxImage() {
      if (lightbox.getAttribute('aria-hidden') !== 'false' || lightboxClosing) return;
      var item = mediaItems[currentIdx];
      if (!item || item.type !== 'image') return;
      resetLightboxZoom(true);
      setLightboxRect(getLightboxTargetRect(getLightboxImageDimensions(item).ratio));
    }

    function closeLightbox() {
      if (lightbox.getAttribute('aria-hidden') === 'true' || lightboxClosing) return;
      lightboxImageRequestId += 1;
      if (lightboxAnimation) {
        lightboxAnimation.cancel();
        lightboxAnimation = null;
      }
      resetLightboxZoom(true);
      lightboxClosing = true;
      lightbox.classList.remove('is-ready');
      lightbox.classList.add('is-closing');

      var currentRect = lightboxImg.getBoundingClientRect();
      var sourceEl = getLightboxSourceElement();
      var endRect = sourceEl.getBoundingClientRect();

      lightboxAnimation = lightboxImg.animate([
        {
          left: currentRect.left + 'px',
          top: currentRect.top + 'px',
          width: currentRect.width + 'px',
          height: currentRect.height + 'px'
        },
        {
          left: endRect.left + 'px',
          top: endRect.top + 'px',
          width: endRect.width + 'px',
          height: endRect.height + 'px'
        }
      ], {
        duration: motionDuration('--motion-duration', '420ms'),
        easing: motionEase('--motion-ease', 'cubic-bezier(0.22, 1, 0.36, 1)'),
        fill: 'forwards'
      });

      lightboxAnimation.onfinish = function () {
        lightbox.setAttribute('aria-hidden', 'true');
        lightbox.setAttribute('inert', '');
        lightbox.classList.remove('is-closing');
        lightboxImg.style.opacity = '';
        lightboxImg.style.left = '';
        lightboxImg.style.top = '';
        lightboxImg.style.width = '';
        lightboxImg.style.height = '';
        window.Axiom.unlockPageScroll(lightbox);
        lightboxAnimation = null;
        lightboxClosing = false;
      };
      lightboxAnimation.oncancel = function () {
        lightbox.classList.remove('is-closing');
        lightboxAnimation = null;
        lightboxClosing = false;
      };
    }

    mainWrap.addEventListener('click', function (event) {
      if (!canOpenLightbox) return;
      if (event.target.closest('[data-media-prev], [data-media-next], [data-split-row-nav]')) return;
      if (window.AxiomProductMedia && window.AxiomProductMedia.isControlTarget(event.target)) return;
      var clickedMediaItem = event.target.closest('[data-media-item]');
      if (!clickedMediaItem || clickedMediaItem.dataset.mediaType !== 'image') return;
      openLightbox();
    });
    var lightboxCloseBtn = queryById(lightbox, 'lightboxClose');
    var lightboxPrevBtn = queryById(lightbox, 'lightboxPrev');
    var lightboxNextBtn = queryById(lightbox, 'lightboxNext');

    if (lightboxCloseBtn) lightboxCloseBtn.addEventListener('click', closeLightbox);
    lightboxPrevBtn && lightboxPrevBtn.addEventListener('click', function () {
      navigateLightbox(-1);
    });
    lightboxNextBtn && lightboxNextBtn.addEventListener('click', function () {
      navigateLightbox(1);
    });
    on(lightbox, 'pointermove', updateLightboxZoomOrigin, { passive: true });
    on(lightbox, 'pointerleave', function () {
      resetLightboxZoom(false);
    });
    on(window, 'resize', resizeLightboxImage);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) {
        closeLightbox();
        return;
      }
      if (e.target === lightboxFrame) {
        closeLightbox();
        return;
      }
      if (lightboxControls && lightboxControls.contains(e.target)) return;
      if (e.target === lightboxImg) return;
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') {
        closeLightbox();
      }
    });
  }

  // ── VARIANT PICKER ────────────────────────────
  var variantIdInput = queryInRoot('[data-variant-id]');
  var productCartStatus = queryInRoot('[data-product-cart-status]');
  var currentOptions = {};

  function getVariantB2BData(variantId) {
    if (!productB2BConfig || !productB2BConfig.variants || !variantId) return null;
    return productB2BConfig.variants[String(variantId)] || null;
  }

  function getVariantQuantityRule(variant) {
    return window.AxiomVariantForm.getQuantityRule(variant, productB2BConfig);
  }

  function shouldCheckVariantInventory(variant) {
    return window.AxiomVariantForm.shouldCheckInventory(variant, productB2BConfig);
  }

  function getVariantInventoryQuantity(variant) {
    return window.AxiomVariantForm.getInventoryQuantity(variant, productB2BConfig);
  }

  function getVariantCartQuantity(variant) {
    var variantState = variant && getVariantB2BData(variant.id);
    return Math.max(0, parseInt(variantState && variantState.cartQuantity, 10) || 0);
  }

  function isQuantityRuleSoldOut(variant) {
    if (window.AxiomVariantForm.isSoldOut(variant, productB2BConfig)) return true;
    return shouldCheckVariantInventory(variant)
      && getVariantInventoryQuantity(variant) < getVariantQuantityRule(variant).min;
  }

  function getEffectiveMaxQty(variant) {
    return window.AxiomVariantForm.getEffectiveMaxQty(variant, productB2BConfig);
  }

  function isCartQuantityLimitReached(variant) {
    if (!variant || isQuantityRuleSoldOut(variant)) return false;
    var max = getEffectiveMaxQty(variant);
    if (max === null) return false;
    var quantityRule = getVariantQuantityRule(variant);
    var minimumAddQuantity = getVariantCartQuantity(variant) >= quantityRule.min
      ? quantityRule.increment
      : quantityRule.min;
    return max < minimumAddQuantity;
  }

  function getProductQuantityBounds(variant) {
    var quantityRule = getVariantQuantityRule(variant);
    var max = getEffectiveMaxQty(variant);
    var min = getVariantCartQuantity(variant) >= quantityRule.min
      ? quantityRule.increment
      : quantityRule.min;
    return { min: min, max: max, increment: quantityRule.increment };
  }

  function normalizeMainQty(rawValue, variant, allowZero) {
    if (!variant || isQuantityRuleSoldOut(variant)) return 0;
    var bounds = getProductQuantityBounds(variant);
    var value = parseInt(rawValue, 10);
    if (!Number.isFinite(value)) value = allowZero ? 0 : bounds.min;
    if (allowZero && value <= 0) return 0;
    if (value < bounds.min) value = bounds.min;
    if (value > bounds.min) value -= (value - bounds.min) % bounds.increment;
    if (bounds.max !== null && value > bounds.max) {
      value = bounds.max;
      if (value >= bounds.min) value -= (value - bounds.min) % bounds.increment;
    }
    return Math.max(allowZero ? 0 : bounds.min, value);
  }

  function getDisplayPricing(variant, purchaseOptionState) {
    var allocation = purchaseOptionState && purchaseOptionState.allocation ? purchaseOptionState.allocation : null;
    return {
      price: allocation && allocation.price != null ? allocation.price : variant.price,
      compareAtPrice: allocation && allocation.compareAtPrice != null ? allocation.compareAtPrice : variant.compare_at_price
    };
  }

  function getAtcActiveLabel(button) {
    return button.dataset.addLabel || productString('addToCart');
  }

  var dynamicCheckoutRoot = queryInRoot('[data-dynamic-checkout]');

  function setVariantLoading(isLoading) {
    var button = queryInRoot('[data-atc-btn]');
    if (button) button.classList.toggle('is-variant-loading', Boolean(isLoading));
    if (dynamicCheckoutRoot) dynamicCheckoutRoot.classList.toggle('is-variant-loading', Boolean(isLoading));
  }

  function setDynamicCheckoutLoading(isLoading) {
    if (!dynamicCheckoutRoot) return;
    dynamicCheckoutRoot.classList.toggle('is-loading', Boolean(isLoading));
  }

  function isDynamicCheckoutActivation(event) {
    var path = event && typeof event.composedPath === 'function'
      ? event.composedPath()
      : [event && event.target];

    return path.some(function (node) {
      return node && node.nodeType === 1 && node.matches && node.matches(
        'shopify-accelerated-checkout, shopify-buy-it-now-button, .shopify-payment-button__button'
      );
    });
  }

  function updateInventoryStatusUI(variant, soldOutByRule) {
    var inventoryStatus = queryInRoot('[data-inventory-status]');
    if (!inventoryStatus || !variant) return;
    var inventoryQty = Math.max(0, getVariantInventoryQuantity(variant));
    var threshold = Math.max(1, parseInt(inventoryStatus.dataset.lowStockThreshold, 10) || 15);
    var showLowStock = productSectionConfig.manualPreorder !== true
      && variant.available
      && !soldOutByRule
      && shouldCheckVariantInventory(variant)
      && inventoryQty > 0
      && inventoryQty <= threshold;
    inventoryStatus.hidden = !showLowStock;
    if (showLowStock) {
      if (window.AxiomInventoryMessage) window.AxiomInventoryMessage.update(inventoryStatus, inventoryQty);
    }
  }

  function updateDynamicCheckoutUI(variant, soldOutByRule, purchaseOptionState, cartLimitReached) {
    if (!dynamicCheckoutRoot || !variant) return;
    var isDisabled = !variant.available || soldOutByRule || cartLimitReached;
    dynamicCheckoutRoot.classList.toggle('dynamic-checkout--disabled', isDisabled);
    dynamicCheckoutRoot.classList.toggle('is-loading', false);
    dynamicCheckoutRoot.dataset.soldOut = isDisabled ? 'true' : 'false';
  }

  function syncProductPurchaseControls(variant, soldOutByRule, purchaseOptionState) {
    var atcButton = queryInRoot('[data-atc-btn]');
    var atcLabel = atcButton ? atcButton.querySelector('.atc-label') : null;
    var stickyRoot = document.getElementById('stickyAtc') || queryById(sectionScope, 'stickyAtc');
    var stickyButton = stickyRoot ? stickyRoot.querySelector('[data-sticky-atc]') : null;
    var stickyLabel = stickyButton ? stickyButton.querySelector('.sticky-btn__label') : null;
    var cartLimitReached = isCartQuantityLimitReached(variant);
    var isPurchasable = variant.available && !soldOutByRule && !cartLimitReached;

    if (atcButton) {
      atcButton.disabled = !isPurchasable;
      if (atcLabel) {
        setMotionButtonText(atcLabel, variant.available && !soldOutByRule
          ? getAtcActiveLabel(atcButton)
          : (atcButton.dataset.soldOutLabel || productString('soldOut')));
      }
    }
    if (stickyButton) {
      stickyButton.disabled = !isPurchasable;
      stickyButton.classList.toggle('is-disabled', !isPurchasable);
      stickyButton.setAttribute('aria-disabled', String(!isPurchasable));
      if (stickyLabel) {
        setMotionButtonText(stickyLabel, variant.available && !soldOutByRule
          ? getAtcActiveLabel(stickyButton)
          : (stickyButton.dataset.soldOutLabel || productString('soldOut')));
      }
    }

    updateDynamicCheckoutUI(variant, soldOutByRule, purchaseOptionState, cartLimitReached);
  }

  function dispatchQuantityChange(variant, quantity) {
    document.dispatchEvent(new CustomEvent('product:quantity:change', {
      detail: {
        productId: productData && productData.id,
        variantId: variant && variant.id,
        quantity: parseInt(quantity, 10) || 0
      }
    }));
  }

  function getSelectedVariant() {
    if (highVariantProduct) return selectedHighVariant;
    return window.AxiomVariantForm.findVariant(productData, currentOptions);
  }

  function syncSelectedOptionsUI(variant) {
    var options = window.AxiomVariantForm.getVariantOptions(variant);
    if (!options.length) return;
    options.forEach(function (value, index) {
      var position = index + 1;
      currentOptions[position] = value;
      queryAllInRoot('[data-option-position="' + position + '"]').forEach(function (item) {
        var isActive = item.dataset.value === value;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      queryAllInRoot('[data-option-selected-value="' + position + '"]').forEach(function (label) {
        label.textContent = value;
      });
    });
  }

  function syncOptionAvailabilityUI() {
    if (highVariantProduct) {
      window.AxiomHighVariantPicker.applyAvailability(sectionEl, '[data-option-position]', highVariantState);
      return;
    }
    queryAllInRoot('[data-option-position]').forEach(function (button) {
      var position = parseInt(button.dataset.optionPosition, 10);
      var candidateVariant = window.AxiomVariantForm.findAvailableVariantForOptionValue(
        productData,
        currentOptions,
        position,
        button.dataset.value,
        productB2BConfig
      );
      var isUnavailable = !candidateVariant;
      button.classList.toggle('unavailable', isUnavailable);
      button.dataset.resolvedOptionVariantId = candidateVariant ? String(candidateVariant.id) : '';
      button.dataset.optionValueAvailable = isUnavailable ? 'false' : 'true';
      button.removeAttribute('aria-disabled');
      var unavailableLabel = button.querySelector('[data-option-unavailable-label]');
      if (unavailableLabel) unavailableLabel.hidden = !isUnavailable;
      if (button.dataset.optionAccessibleLabel) {
        button.setAttribute('aria-label', button.dataset.optionAccessibleLabel + (isUnavailable && unavailableLabel ? unavailableLabel.textContent : ''));
      }
    });
  }

  function syncVariantImageSwatchesUI() {
    if (!window.AxiomVariantForm || typeof window.AxiomVariantForm.syncVariantImageSwatches !== 'function') return;
    window.AxiomVariantForm.syncVariantImageSwatches({
      root: sectionEl,
      buttonSelector: '[data-option-position]',
      product: productData,
      selected: window.AxiomVariantForm.selectedOptions(sectionEl, '[data-option-position]'),
      contextualState: highVariantProduct ? highVariantState : null
    });
  }

  function formatSaveLabel(compare, price, template, mode) {
    var savings = compare - price;
    var replacement = money(savings);
    if (mode === 'percent' && compare > 0) {
      replacement = String(Math.round((savings * 100) / compare)) + '%';
    }
    return String(template || productString('saving'))
      .replace('[amount]', replacement)
      .replace('[percent]', replacement);
  }

  function setUnavailableSelectionUI() {
    setVariantLoading(false);
    var unavailableLabel = productString('unavailable');
    var priceEl = queryInRoot('[data-price]');
    var compareEl = queryInRoot('[data-compare-price]');
    var saveEl = queryInRoot('[data-save-badge]');
    var unitPriceEl = queryInRoot('[data-unit-price]');
    var atcButton = queryInRoot('[data-atc-btn]');
    var atcLabel = atcButton ? atcButton.querySelector('.atc-label') : null;
    var inventoryStatus = queryInRoot('[data-inventory-status]');
    var skuEl = queryInRoot('[data-sku]');
    var stickyRoot = document.getElementById('stickyAtc') || queryById(sectionScope, 'stickyAtc');
    var stickyPrice = stickyRoot ? stickyRoot.querySelector('[data-sticky-price]') : null;
    var stickyVariant = stickyRoot ? stickyRoot.querySelector('#stickyVariant') : null;
    var stickyButton = stickyRoot ? stickyRoot.querySelector('[data-sticky-atc]') : null;
    var stickyLabel = stickyButton ? stickyButton.querySelector('.sticky-btn__label') : null;

    if (variantIdInput) variantIdInput.value = '';

    if (priceEl) {
      priceEl.textContent = unavailableLabel;
      priceEl.removeAttribute('aria-label');
      priceEl.classList.add('price-current--unavailable');
    }
    if (compareEl) compareEl.style.display = 'none';
    if (saveEl) saveEl.style.display = 'none';
    if (unitPriceEl) {
      unitPriceEl.textContent = '';
      unitPriceEl.removeAttribute('aria-label');
      unitPriceEl.hidden = true;
    }
    if (skuEl) skuEl.textContent = '';

    if (atcButton) {
      atcButton.disabled = true;
      atcButton.classList.remove('loading', 'added');
    }
    setMotionButtonText(atcLabel, unavailableLabel);
    if (stickyButton) {
      stickyButton.disabled = true;
      stickyButton.classList.add('is-disabled');
      stickyButton.setAttribute('aria-disabled', 'true');
    }
    setMotionButtonText(stickyLabel, unavailableLabel);
    if (stickyPrice) stickyPrice.textContent = '';
    if (stickyVariant) stickyVariant.textContent = '';

    if (qtyInput) qtyInput.value = '0';
    if (qtyVal) qtyVal.textContent = '0';
    if (qtyMinusBtn) qtyMinusBtn.disabled = true;
    if (qtyPlusBtn) qtyPlusBtn.disabled = true;
    dispatchQuantityChange(null, 0);

    if (inventoryStatus) {
      // The inventory block is a low-stock notice, not the variant availability owner.
      // Preserve its Liquid/RTE markup so a later valid variant can update {count}.
      inventoryStatus.hidden = true;
    }
    if (dynamicCheckoutRoot) {
      dynamicCheckoutRoot.classList.add('dynamic-checkout--disabled');
      dynamicCheckoutRoot.classList.remove('is-loading');
      dynamicCheckoutRoot.dataset.soldOut = 'true';
    }

    var url = new URL(window.location.href);
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url.toString());
  }

  function updateVariantUI(variant, options) {
    setVariantLoading(false);
    options = options || {};
    setProductCartStatus('');
    if (!variant) {
      if (window.AxiomProductBadges) {
        window.AxiomProductBadges.update(root, { productId: productData && productData.id, available: false, price: 0, compareAtPrice: 0, purchaseOptionLabel: '' });
      }
      setUnavailableSelectionUI();
      syncOptionAvailabilityUI();
      syncVariantImageSwatchesUI();
      if (window.AxiomStandardStorefront && typeof window.AxiomStandardStorefront.dispatchProductSelect === 'function') {
        window.AxiomStandardStorefront.dispatchProductSelect(sectionEl, productData, null);
      }
      return;
    }
    syncSelectedOptionsUI(variant);
    if (variantIdInput) variantIdInput.value = variant.id;
    var priceEl = queryInRoot('[data-price]');
    var priceBlock = queryInRoot('[data-price-block]');
    var compareEl = queryInRoot('[data-compare-price]');
    var saveEl = queryInRoot('[data-save-badge]');
    var atcBtn = queryInRoot('[data-atc-btn]');
    var stickyRoot = document.getElementById('stickyAtc') || queryById(sectionScope, 'stickyAtc');
    var stickyPrice = stickyRoot ? stickyRoot.querySelector('[data-sticky-price]') : null;
    var stickyButton = stickyRoot ? stickyRoot.querySelector('[data-sticky-atc]') : null;
    var stickyThumb = stickyRoot ? stickyRoot.querySelector('.sticky-thumb') : null;
    var skuEl = queryInRoot('[data-sku]');
    var unitPriceEl = queryInRoot('[data-unit-price]');
    var purchaseOptionState = null;
    var displayPricing = getDisplayPricing(variant, purchaseOptionState);
    var price = displayPricing.price;
    var compare = displayPricing.compareAtPrice;
    var soldOutByRule = isQuantityRuleSoldOut(variant);
    if (window.AxiomProductBadges) {
      window.AxiomProductBadges.update(root, {
        productId: productData && productData.id,
        available: variant.available,
        price: variant.price,
        compareAtPrice: variant.compare_at_price,
        purchaseOptionLabel: purchaseOptionState && purchaseOptionState.purchaseOptionLabel,
      });
    }
    if (priceEl) priceEl.classList.remove('price-current--unavailable');
    if (priceEl) {
      priceEl.textContent = money(price);
      priceEl.setAttribute('aria-label', (compare && compare > price ? priceBlock && priceBlock.dataset.salePriceLabel : priceBlock && priceBlock.dataset.regularPriceLabel) + ': ' + money(price));
    }
    var atcPriceCurrent = queryInRoot('[data-atc-price-current]');
    var atcPriceCompare = queryInRoot('[data-atc-price-compare]');
    if (atcPriceCurrent) atcPriceCurrent.textContent = money(price);
    if (atcPriceCompare) {
      if (compare && compare > price) {
        atcPriceCompare.hidden = false;
        atcPriceCompare.textContent = money(compare);
      } else {
        atcPriceCompare.hidden = true;
        atcPriceCompare.textContent = '';
      }
    }
    if (stickyPrice) stickyPrice.textContent = money(price);
    if (compare && compare > price) {
      if (compareEl) {
        compareEl.textContent = money(compare);
        compareEl.setAttribute('aria-label', (priceBlock && priceBlock.dataset.regularPriceLabel) + ': ' + money(compare));
        compareEl.style.display = '';
      }
      if (saveEl) {
        var savingTemplate = atcBtn ? (atcBtn.dataset.savingLabel || productString('saving')) : productString('saving');
        var savingMode = atcBtn ? (atcBtn.dataset.savingMode || 'amount') : 'amount';
        saveEl.textContent = formatSaveLabel(compare, price, savingTemplate, savingMode);
        saveEl.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (saveEl) saveEl.style.display = 'none';
    }

    if (unitPriceEl) {
      if (variant.unit_price && variant.unit_price_measurement) {
        var measurement = variant.unit_price_measurement;
        var referenceValue = measurement.reference_value && measurement.reference_value !== 1 ? measurement.reference_value : '';
        unitPriceEl.textContent = money(variant.unit_price) + ' / ' + referenceValue + measurement.reference_unit;
        unitPriceEl.setAttribute('aria-label', (priceBlock && priceBlock.dataset.unitPriceLabel) + ': ' + unitPriceEl.textContent);
        unitPriceEl.hidden = false;
      } else {
        unitPriceEl.textContent = '';
        unitPriceEl.removeAttribute('aria-label');
        unitPriceEl.hidden = true;
      }
    }

    syncProductPurchaseControls(variant, soldOutByRule, purchaseOptionState);

    if (skuEl && variant.sku) skuEl.textContent = variant.sku;

    var stickyVariant = stickyRoot ? stickyRoot.querySelector('#stickyVariant') : null;
    if (stickyVariant) stickyVariant.textContent = variant.title !== 'Default Title' ? variant.title : '';

    if (window.AxiomAddToCartAnimation) {
      var fallbackAnimationImage = atcBtn ? atcBtn.dataset.atcAnimationFallback : '';
      var animationImage = window.AxiomAddToCartAnimation.imageForVariant(variant, fallbackAnimationImage);
      window.AxiomAddToCartAnimation.setImage(atcBtn, animationImage);
      window.AxiomAddToCartAnimation.setImage(stickyButton, animationImage);
      if (stickyThumb && animationImage) {
        stickyThumb.removeAttribute('srcset');
        stickyThumb.removeAttribute('sizes');
        stickyThumb.src = animationImage;
      }
    }

    if (variant.featured_media && variant.featured_media.id) {
      setMediaById(variant.featured_media.id, options);
    } else if (variant.featured_image && variant.featured_image.id) {
      setMediaById(variant.featured_image.id, options);
    }

    syncMainQtyControls(variant, true);
    updateInventoryStatusUI(variant, soldOutByRule);
    syncOptionAvailabilityUI();
    syncVariantImageSwatchesUI();

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
    if (window.AxiomStandardStorefront && typeof window.AxiomStandardStorefront.dispatchProductSelect === 'function') {
      window.AxiomStandardStorefront.dispatchProductSelect(sectionEl, productData, variant);
    }
    if (window.AxiomSellingPlan) window.AxiomSellingPlan.syncWithin(sectionEl, variant.id);
  }

  queryAllInRoot('[data-option-position]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = parseInt(btn.dataset.optionPosition, 10);
      var val = btn.dataset.value;
      currentOptions[pos] = val;

      var btnGroup = queryAllInRoot('[data-option-position="' + pos + '"]');
      btnGroup.forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');

      var colorLabel = queryInRoot('[id^="colorSelected-"]');
      if (colorLabel && btn.dataset.color) colorLabel.textContent = val;
      queryAllInRoot('[data-option-selected-value="' + pos + '"]').forEach(function (label) {
        label.textContent = val;
      });

      var shouldScrollMedia = btn.hasAttribute('data-variant-media-scroll');
      if (highVariantProduct) {
        if (highVariantRequest) highVariantRequest.abort();
        highVariantRequest = new AbortController();
        var request = highVariantRequest;
        selectedHighVariant = null;
        setVariantLoading(true);
        if (window.AxiomVariantForm && typeof window.AxiomVariantForm.setVariantImageSwatchesLoading === 'function') {
          window.AxiomVariantForm.setVariantImageSwatchesLoading({
            root: sectionEl,
            buttonSelector: '[data-option-position]'
          }, true);
        }
        if (variantIdInput) variantIdInput.value = '';
        var pendingAtc = queryInRoot('[data-atc-btn]');
        if (pendingAtc) pendingAtc.disabled = true;
        var pendingSticky = document.getElementById('stickyAtc');
        var pendingStickyButton = pendingSticky && pendingSticky.querySelector('[data-sticky-atc]');
        if (pendingStickyButton) pendingStickyButton.disabled = true;
        if (dynamicCheckoutRoot) dynamicCheckoutRoot.classList.add('dynamic-checkout--disabled');
        window.AxiomHighVariantPicker.request(
          highVariantState.productUrl,
          window.AxiomHighVariantPicker.selectedOptionValueIds(sectionEl, '[data-option-position]'),
          request.signal
        ).then(function (state) {
          if (request !== highVariantRequest) return;
          highVariantRequest = null;
          highVariantState = state;
          selectedHighVariant = state.variant;
          if (state.variant && state.variantState) {
            productB2BConfig.variants = productB2BConfig.variants || {};
            productB2BConfig.variants[String(state.variant.id)] = state.variantState;
            sectionEl.dispatchEvent(new CustomEvent('product:variant-state', {
              detail: {
                productId: productData && productData.id,
                variantId: state.variant.id,
                variantState: state.variantState
              }
            }));
          }
          updateVariantUI(state.variant, {
            scrollMedia: shouldScrollMedia,
            scrollThumb: shouldScrollMedia
          });
        }).catch(function (error) {
          if (error.name === 'AbortError' || request !== highVariantRequest) return;
          highVariantRequest = null;
          if (window.AxiomVariantForm && typeof window.AxiomVariantForm.setVariantImageSwatchesLoading === 'function') {
            window.AxiomVariantForm.setVariantImageSwatchesLoading({
              root: sectionEl,
              buttonSelector: '[data-option-position]'
            }, false);
          }
          setUnavailableSelectionUI();
          setProductCartStatus(error.message || productString('unavailable'));
        });
        return;
      }
      updateVariantUI(getSelectedVariant(), {
        scrollMedia: shouldScrollMedia,
        scrollThumb: shouldScrollMedia
      });
    });
  });

  // Init current options from DOM
  queryAllInRoot('[data-option-position].active').forEach(function (btn) {
    currentOptions[parseInt(btn.dataset.optionPosition, 10)] = btn.dataset.value;
  });
  syncVariantImageSwatchesUI();

  // ── QUANTITY ──────────────────────────────────
  var qtyInput = queryInRoot('[data-qty-input]');
  var qtyVal = queryInRoot('[data-qty-val]');
  var qtyMinusBtn = queryInRoot('[data-qty-minus]');
  var qtyPlusBtn = queryInRoot('[data-qty-plus]');

  function getActiveVariantForQty() {
    if (highVariantProduct) {
      return selectedHighVariant && variantIdInput && String(selectedHighVariant.id) === String(variantIdInput.value)
        ? selectedHighVariant : null;
    }
    if (!variantIdInput || !variantIdInput.value || !productData || !productData.variants) return null;
    return productData.variants.find(function (variant) {
      return String(variant.id) === String(variantIdInput.value);
    }) || null;
  }

  function syncMainQtyControls(variant, keepCurrentValue) {
    if (!qtyInput || !qtyVal || !variant) return;
    var quantityRule = getVariantQuantityRule(variant);
    var bounds = getProductQuantityBounds(variant);
    var soldOutByRule = isQuantityRuleSoldOut(variant);
    var cartLimitReached = isCartQuantityLimitReached(variant);
    var max = bounds.max;
    var nextQty = soldOutByRule
      ? 0
      : cartLimitReached
        ? bounds.min
        : normalizeMainQty(keepCurrentValue ? qtyInput.value : quantityRule.min, variant, false);

    qtyInput.value = nextQty;
    qtyVal.textContent = nextQty;
    qtyInput.min = bounds.min;
    qtyInput.step = quantityRule.increment;
    if (max !== null && max >= bounds.min) {
      qtyInput.max = max;
    } else {
      qtyInput.removeAttribute('max');
    }

    if (qtyMinusBtn) qtyMinusBtn.disabled = soldOutByRule || cartLimitReached || nextQty <= bounds.min;
    if (qtyPlusBtn) qtyPlusBtn.disabled = soldOutByRule || cartLimitReached || (max !== null && nextQty >= max);
    if (cartLimitReached) setProductCartStatus(productString('maximumQuantityInBag'));
    dispatchQuantityChange(variant, nextQty);
  }

  if (qtyMinusBtn) {
    qtyMinusBtn.addEventListener('click', function () {
      var activeVariant = getActiveVariantForQty();
      if (!activeVariant || !qtyInput || !qtyVal) return;
      var quantityRule = getVariantQuantityRule(activeVariant);
      var currentQty = parseInt(qtyInput.value || quantityRule.min, 10) || quantityRule.min;
      var nextQty = normalizeMainQty(currentQty - quantityRule.increment, activeVariant, false);
      qtyInput.value = nextQty;
      qtyVal.textContent = nextQty;
      setProductCartStatus('');
      syncMainQtyControls(activeVariant, true);
    });
  }

  if (qtyPlusBtn) {
    qtyPlusBtn.addEventListener('click', function () {
      var activeVariant = getActiveVariantForQty();
      if (!activeVariant || !qtyInput || !qtyVal) return;
      var quantityRule = getVariantQuantityRule(activeVariant);
      var currentQty = parseInt(qtyInput.value || quantityRule.min, 10) || quantityRule.min;
      var requestedQuantity = currentQty + quantityRule.increment;
      var nextQty = normalizeMainQty(requestedQuantity, activeVariant, false);
      qtyInput.value = nextQty;
      qtyVal.textContent = nextQty;
      var effectiveMax = getEffectiveMaxQty(activeVariant);
      setProductCartStatus(effectiveMax !== null && requestedQuantity >= effectiveMax
        ? quantityLimitMessage(effectiveMax)
        : '');
      syncMainQtyControls(activeVariant, true);
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var activeVariant = getActiveVariantForQty();
      if (!activeVariant || !qtyVal) return;
      var rawQuantity = parseInt(qtyInput.value, 10);
      var nextQty = normalizeMainQty(rawQuantity, activeVariant, false);
      qtyInput.value = nextQty;
      qtyVal.textContent = nextQty;
      var effectiveMax = getEffectiveMaxQty(activeVariant);
      setProductCartStatus(effectiveMax !== null && Number.isFinite(rawQuantity) && rawQuantity >= effectiveMax
        ? quantityLimitMessage(effectiveMax)
        : '');
      syncMainQtyControls(activeVariant, true);
    });
  }

  var initialVariant = getSelectedVariant();
  if (initialVariant) {
    updateVariantUI(initialVariant);
  }

  // â”€â”€ AJAX PRODUCT FORM â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var productForm = queryInRoot('[data-product-form]');
  var giftCardRecipient = queryInRoot('[data-gift-card-recipient]');
  var giftCardRecipientToggle = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-toggle]');
  var giftCardRecipientFields = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-fields]');
  var giftCardRecipientEmail = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-email]');
  var giftCardRecipientSendOn = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-send-on]');
  var giftCardRecipientOffset = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-offset]');
  var giftCardRecipientError = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-error]');
  var giftCardRecipientStatus = giftCardRecipient && giftCardRecipient.querySelector('[data-gift-card-recipient-status]');
  function setProductCartStatus(message) {
    if (!productCartStatus) return;
    var nextMessage = String(message || '').trim();
    productCartStatus.textContent = '';
    productCartStatus.hidden = !nextMessage;
    if (!nextMessage) return;
    window.requestAnimationFrame(function () {
      if (productCartStatus && productCartStatus.isConnected) productCartStatus.textContent = nextMessage;
    });
  }

  function quantityLimitMessage(count) {
    var cartApi = window.AxiomStandardStorefront;
    return cartApi && typeof cartApi.quantityLimitMessage === 'function'
      ? cartApi.quantityLimitMessage(count)
      : 'You can only add ' + Math.max(0, parseInt(count, 10) || 0) + ' of this item to your bag.';
  }

  function productInventoryWarning(message, result, variant, requestedQuantity) {
    var cartApi = window.AxiomStandardStorefront;
    if (!cartApi || typeof cartApi.getCartLines !== 'function' || !result || !result.cart || !variant) return message;
    var variantId = String(variant.id);
    var resultQuantity = cartApi.getCartLines(result.cart).reduce(function (total, line) {
      var merchandiseId = line && line.merchandise && line.merchandise.id || line && line.merchandiseId || '';
      return String(merchandiseId).split('/').pop() === variantId
        ? total + (parseInt(line.quantity, 10) || 0)
        : total;
    }, 0);
    var allowedQuantity = Math.max(0, resultQuantity - getVariantCartQuantity(variant));
    return allowedQuantity < requestedQuantity ? quantityLimitMessage(allowedQuantity) : message;
  }

  function syncProductCartQuantity(result, variant) {
    var variantState = variant && getVariantB2BData(variant.id);
    var cartApi = window.AxiomStandardStorefront;
    if (!variantState || !result || !result.cart || !cartApi || typeof cartApi.getCartLines !== 'function') return;
    var variantId = String(variant.id);
    variantState.cartQuantity = cartApi.getCartLines(result.cart).reduce(function (total, line) {
      var merchandiseId = line && line.merchandise && line.merchandise.id || line && line.merchandiseId || '';
      if (String(merchandiseId).split('/').pop() !== variantId) return total;
      return total + (parseInt(line.quantity, 10) || 0);
    }, 0);
  }

  function syncProductCartState(result) {
    var activeVariant = getActiveVariantForQty() || getSelectedVariant();
    if (!activeVariant || !result || !result.cart) return;
    setProductCartStatus('');
    syncProductCartQuantity(result, activeVariant);
    var purchaseOptionState = null;
    syncProductPurchaseControls(activeVariant, isQuantityRuleSoldOut(activeVariant), purchaseOptionState);
    syncMainQtyControls(activeVariant, false);
    updateInventoryStatusUI(activeVariant, isQuantityRuleSoldOut(activeVariant));
  }

  on(document, 'shopify:cart:lines-update', function (event) {
    if (!event || !event.promise) return;
    var eventDetail = event.detail || {};
    var source = eventDetail.source || eventDetail.detail && eventDetail.detail.source || '';
    if (source === 'product') return;
    event.promise.then(function (result) {
      if (result && Array.isArray(result.userErrors) && result.userErrors.length) return;
      syncProductCartState(result);
    }).catch(function () {});
  });

  function formatRecipientDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function syncGiftCardRecipient() {
    if (!giftCardRecipientToggle || !giftCardRecipientFields) return;
    var enabled = giftCardRecipientToggle.checked;
    giftCardRecipientToggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');
    giftCardRecipientFields.hidden = !enabled;
    giftCardRecipientFields.querySelectorAll('input, textarea').forEach(function (field) {
      field.disabled = !enabled;
      if (!enabled) field.value = '';
    });
    if (giftCardRecipientEmail) giftCardRecipientEmail.required = enabled;
    if (giftCardRecipientEmail) giftCardRecipientEmail.removeAttribute('aria-invalid');
    if (giftCardRecipientSendOn) giftCardRecipientSendOn.removeAttribute('aria-invalid');
    if (giftCardRecipientOffset && enabled) giftCardRecipientOffset.value = String(new Date().getTimezoneOffset());
    if (giftCardRecipientError) giftCardRecipientError.hidden = true;
  }

  function validateGiftCardRecipient(event) {
    if (!giftCardRecipientToggle || !giftCardRecipientToggle.checked || !giftCardRecipientEmail) return;
    if (giftCardRecipientEmail.checkValidity() && (!giftCardRecipientSendOn || giftCardRecipientSendOn.checkValidity())) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (giftCardRecipientError) giftCardRecipientError.hidden = false;
    if (giftCardRecipientStatus && giftCardRecipientError) giftCardRecipientStatus.textContent = giftCardRecipientError.textContent;
    var invalidField = giftCardRecipientEmail.checkValidity() ? giftCardRecipientSendOn : giftCardRecipientEmail;
    if (giftCardRecipientEmail) giftCardRecipientEmail.setAttribute('aria-invalid', giftCardRecipientEmail.checkValidity() ? 'false' : 'true');
    if (giftCardRecipientSendOn) giftCardRecipientSendOn.setAttribute('aria-invalid', giftCardRecipientSendOn.checkValidity() ? 'false' : 'true');
    if (invalidField && typeof invalidField.reportValidity === 'function') invalidField.reportValidity();
  }

  if (giftCardRecipientToggle) {
    var recipientToday = new Date();
    var recipientMaxDate = new Date(recipientToday.getFullYear(), recipientToday.getMonth(), recipientToday.getDate() + 90);
    if (giftCardRecipientSendOn) {
      giftCardRecipientSendOn.min = formatRecipientDate(recipientToday);
      giftCardRecipientSendOn.max = formatRecipientDate(recipientMaxDate);
    }
    giftCardRecipientToggle.addEventListener('change', syncGiftCardRecipient);
    syncGiftCardRecipient();
  }
  function showAtcAddedFeedback(result) {
    if (!atcBtn) return;
    var activeVariant = getActiveVariantForQty() || getSelectedVariant();
    if (activeVariant) {
      syncProductCartQuantity(result, activeVariant);
      var purchaseOptionState = null;
      syncProductPurchaseControls(activeVariant, isQuantityRuleSoldOut(activeVariant), purchaseOptionState);
      syncMainQtyControls(activeVariant, false);
      updateInventoryStatusUI(activeVariant, isQuantityRuleSoldOut(activeVariant));
    }
    atcBtn.classList.remove('loading');
    if (window.AxiomAddToCartAnimation && window.AxiomAddToCartAnimation.isEnabled()) {
      atcBtn.classList.remove('added');
      var activeLabel = atcBtn.querySelector('.atc-label');
      if (activeLabel && activeVariant) setMotionButtonText(activeLabel, getAtcActiveLabel(atcBtn));
      if (atcFeedbackTimer) {
        window.clearTimeout(atcFeedbackTimer);
        atcFeedbackTimer = null;
      }
      if (giftCardRecipientStatus && giftCardRecipientToggle && giftCardRecipientToggle.checked) {
        giftCardRecipientStatus.textContent = atcBtn.dataset.addedLabel || productString('added');
        giftCardRecipientToggle.checked = false;
        syncGiftCardRecipient();
      }
      return;
    }
    atcBtn.classList.add('added');
    var label = atcBtn.querySelector('.atc-label');
    setMotionButtonText(label, atcBtn.dataset.addedLabel || productString('added'));
    if (giftCardRecipientStatus && giftCardRecipientToggle && giftCardRecipientToggle.checked) {
      giftCardRecipientStatus.textContent = atcBtn.dataset.addedLabel || productString('added');
      giftCardRecipientToggle.checked = false;
      syncGiftCardRecipient();
    }
    if (atcFeedbackTimer) {
      window.clearTimeout(atcFeedbackTimer);
    }
    atcFeedbackTimer = window.setTimeout(function () {
      atcBtn.classList.remove('added');
      var currentVariant = getActiveVariantForQty();
      if (label && currentVariant) setMotionButtonText(label, getAtcActiveLabel(atcBtn));
    }, 2000);
  }

  if (productForm) {
    productForm.addEventListener('submit', validateGiftCardRecipient, true);
    productForm.addEventListener('submit', function (event) {
      var customOptionValidation = window.AxiomCustomOptions && typeof window.AxiomCustomOptions.validate === 'function'
        ? window.AxiomCustomOptions.validate(productForm)
        : { valid: true };
      if (!customOptionValidation.valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setProductCartStatus(customOptionValidation.message);
        return;
      }
      var submitter = getFormSubmitter(event);
      if (!submitter || !submitter.matches('[data-atc-btn]')) {
        if (window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(productForm)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setDynamicCheckoutLoading(true);
          window.AxiomStandardStorefront.addProductForm(productForm, {
            target: productForm,
            source: 'product',
            redirectToCheckout: true
          }).catch(function (error) {
            setDynamicCheckoutLoading(false);
            setProductCartStatus(error && error.message || cartString('addError'));
          });
          return;
        }
        var checkoutVariant = getActiveVariantForQty() || getSelectedVariant();
        var checkoutPlanValidation = window.AxiomSellingPlan && checkoutVariant
          ? window.AxiomSellingPlan.validateVariant(productForm, getVariantB2BData(checkoutVariant.id) || checkoutVariant)
          : { valid: true };
        if (!checkoutPlanValidation.valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!checkoutPlanValidation.displayed) setProductCartStatus(checkoutPlanValidation.message);
          return;
        }
        if (dynamicCheckoutRoot && dynamicCheckoutRoot.classList.contains('dynamic-checkout--disabled')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        setDynamicCheckoutLoading(true);
        return;
      }
      event.preventDefault();
      if (!variantIdInput || !variantIdInput.value) return;
      if (atcBtn && atcBtn.disabled) return;
      var activeVariant = getActiveVariantForQty() || getSelectedVariant();
      var planValidation = window.AxiomSellingPlan && activeVariant
        ? window.AxiomSellingPlan.validateVariant(productForm, getVariantB2BData(activeVariant.id) || activeVariant)
        : { valid: true };
      if (!planValidation.valid) {
        if (!planValidation.displayed) setProductCartStatus(planValidation.message);
        return;
      }
      setProductCartStatus('');
      if (window.AxiomAddToCartAnimation) {
        var animationContext = atcBtn && atcBtn._axiomAnimationContext;
        if (atcBtn) delete atcBtn._axiomAnimationContext;
        window.AxiomAddToCartAnimation.play({
          button: animationContext && animationContext.button || atcBtn,
          source: animationContext && animationContext.source,
          imageUrl: animationContext && animationContext.imageUrl || window.AxiomAddToCartAnimation.imageForVariant(activeVariant, atcBtn && atcBtn.dataset.atcAnimationFallback),
          mode: animationContext && animationContext.mode || 'main'
        });
      }
      if (atcBtn) atcBtn.classList.add('loading');
      var customOptionValidation = window.AxiomCustomOptions && typeof window.AxiomCustomOptions.validate === 'function'
        ? window.AxiomCustomOptions.validate(productForm)
        : { valid: true };
      if (!customOptionValidation.valid) {
        setProductCartStatus(customOptionValidation.message);
        if (atcBtn) atcBtn.classList.remove('loading');
        return;
      }
      var addRequest = window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(productForm)
        ? window.AxiomStandardStorefront.addProductForm(productForm, { target: productForm, source: 'product' })
        : window.AxiomStandardStorefront.addLines({
            id: parseInt(variantIdInput.value, 10),
            quantity: qtyInput ? parseInt(qtyInput.value || '1', 10) : 1,
            properties: window.AxiomVariantForm.collectProperties(productForm),
            sellingPlanId: sellingPlanIdFromForm(productForm)
          }, {
            target: productForm,
            source: 'product',
            onWarning: function (message, result) {
              var requestedQuantity = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
              setProductCartStatus(productInventoryWarning(message, result, activeVariant, requestedQuantity));
            }
          });
      addRequest.then(showAtcAddedFeedback).catch(function (error) {
        var effectiveMax = activeVariant && getEffectiveMaxQty(activeVariant);
        setProductCartStatus(error && error.code === 'MAXIMUM_EXCEEDED' && effectiveMax !== null
          ? quantityLimitMessage(effectiveMax)
          : error && error.message || cartString('addError'));
        if (atcBtn) atcBtn.classList.remove('loading');
      });
    });
  }
  if (dynamicCheckoutRoot) {
    on(dynamicCheckoutRoot, 'click', function (event) {
      if (!isDynamicCheckoutActivation(event)) return;

      if (window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(productForm)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var fileCheckoutValidation = window.AxiomCustomOptions && typeof window.AxiomCustomOptions.validate === 'function'
          ? window.AxiomCustomOptions.validate(productForm)
          : { valid: true };
        if (!fileCheckoutValidation.valid) {
          setProductCartStatus(fileCheckoutValidation.message);
          return;
        }
        setDynamicCheckoutLoading(true);
        window.AxiomStandardStorefront.addProductForm(productForm, {
          target: productForm,
          source: 'product',
          redirectToCheckout: true
        }).catch(function (error) {
          setDynamicCheckoutLoading(false);
          setProductCartStatus(error && error.message || cartString('addError'));
        });
        return;
      }

      if (dynamicCheckoutRoot.classList.contains('dynamic-checkout--disabled')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var activeVariant = getActiveVariantForQty() || getSelectedVariant();
        return;
      }
      setDynamicCheckoutLoading(true);
    }, true);
    on(window, 'pageshow', function () {
      setDynamicCheckoutLoading(false);
    });
  }

  // ── ATC FEEDBACK ──────────────────────────────
  var atcBtn = queryInRoot('[data-atc-btn]');
  if (atcBtn) {
    on(document, 'shopify:cart:error', function () {
      atcBtn.classList.remove('loading');
      if (giftCardRecipientToggle && giftCardRecipientToggle.checked && giftCardRecipientError) {
        giftCardRecipientError.hidden = false;
        if (giftCardRecipientStatus) giftCardRecipientStatus.textContent = giftCardRecipientError.textContent;
      }
    });
  }

  // ── STICKY ATC ────────────────────────────────
  var stickyAtc = queryById(sectionScope, 'stickyAtc');
  var anchor = queryById(sectionEl, 'productFormAnchor');
  var secondDetailsContainer = sectionEl.querySelector('[data-product-container="second"]');
  var mediaGallery = queryInRoot('[data-media-gallery]');
  portalStickyAtc(stickyAtc);
  function setScrollToTopOffset(offset) {
    document.documentElement.style.setProperty('--scroll-to-top-sticky-offset', Math.max(0, offset || 0) + 'px');
  }
  function updateScrollToTopOffset() {
    if (!stickyAtc || !stickyAtc.classList.contains('visible')) {
      setScrollToTopOffset(0);
      return;
    }
    var rect = stickyAtc.getBoundingClientRect();
    var extraGap = stickyAtc.classList.contains('sticky-atc--floating_corner') ? 16 : 12;
    setScrollToTopOffset(rect.height + extraGap);
  }
  if (stickyAtc && anchor) {
    function updateStickyAtcVisibility() {
      var viewportHeight = document.documentElement.clientHeight;
      var anchorRect = anchor.getBoundingClientRect();
      var detailsTop = anchorRect.top;
      var detailsBottom = anchorRect.bottom;
      if (secondDetailsContainer) {
        var secondRect = secondDetailsContainer.getBoundingClientRect();
        detailsTop = Math.min(detailsTop, secondRect.top);
        detailsBottom = Math.max(detailsBottom, secondRect.bottom);
      }
      var show = detailsBottom <= 0 || detailsTop >= viewportHeight;

      if (window.matchMedia('(max-width: 767px)').matches && stickyAtc.dataset.mobileStickyAtcOnTop !== 'true') {
        var mediaPassed = mediaGallery
          ? mediaGallery.getBoundingClientRect().bottom <= 0
          : atcBtn && atcBtn.getBoundingClientRect().bottom <= 0;
        var buttonRect = atcBtn && atcBtn.getBoundingClientRect();
        var buttonVisible = buttonRect && buttonRect.bottom > 0 && buttonRect.top < viewportHeight;
        show = Boolean(mediaPassed && !buttonVisible);
      }

      stickyAtc.classList.toggle('visible', show);
      stickyAtc.setAttribute('aria-hidden', String(!show));
      stickyAtc.toggleAttribute('inert', !show);
      updateScrollToTopOffset();
    }
    stickyObs = new IntersectionObserver(function () {
      updateStickyAtcVisibility();
    }, { threshold: 0 });
    stickyObs.observe(anchor);
    if (secondDetailsContainer) stickyObs.observe(secondDetailsContainer);
    if (mediaGallery) stickyObs.observe(mediaGallery);
    if (atcBtn) stickyObs.observe(atcBtn);
    if (typeof ResizeObserver !== 'undefined') {
      stickyResizeObserver = new ResizeObserver(function () {
        updateScrollToTopOffset();
      });
      stickyResizeObserver.observe(stickyAtc);
    }
    on(window, 'resize', updateStickyAtcVisibility);
    updateStickyAtcVisibility();
  } else {
    setScrollToTopOffset(0);
  }
  var stickyBtn = stickyAtc ? stickyAtc.querySelector('[data-sticky-atc]') : null;
  if (stickyBtn && atcBtn) {
    stickyBtn.addEventListener('click', function () {
      var stickyThumb = stickyAtc.querySelector('.sticky-thumb');
      atcBtn._axiomAnimationContext = {
        button: stickyBtn,
        source: stickyThumb || stickyBtn,
        imageUrl: stickyBtn.dataset.atcAnimationImage || '',
        mode: 'sticky'
      };
      atcBtn.click();
      delete atcBtn._axiomAnimationContext;
    });
  }

  // ── SHARE ─────────────────────────────────────
  var shareBtn = queryInRoot('[data-share-btn]');
  if (shareBtn && window.Axiom && window.Axiom.initShareButtons) {
    window.Axiom.initShareButtons();
  }

  sectionEl.__productCleanup = function () {
    if (highVariantRequest) highVariantRequest.abort();
    pauseProductMedia();
    if (galleryController) {
      galleryController.dispose();
    }
    cleanups.forEach(function (cleanup) {
      cleanup();
    });
    cleanups = [];

    if (stickyObs) {
      stickyObs.disconnect();
      stickyObs = null;
    }

    if (stickyResizeObserver) {
      stickyResizeObserver.disconnect();
      stickyResizeObserver = null;
    }

    if (stickyAtc && stickyAtc.parentNode === document.body) {
      stickyAtc.remove();
    }

    if (atcFeedbackTimer) {
      window.clearTimeout(atcFeedbackTimer);
      atcFeedbackTimer = null;
    }

    if (lightboxAnimation) {
      lightboxAnimation.cancel();
      lightboxAnimation = null;
    }

    if (lightbox) {
      if (lightbox.getAttribute('aria-hidden') === 'false') {
        window.Axiom.unlockPageScroll(lightbox);
      }
      lightbox.classList.remove('is-active', 'is-closing', 'is-zoomed');
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.setAttribute('inert', '');
      if (lightbox.parentNode === document.body) {
        lightbox.remove();
      }
    }

    if (mainWrap) {
      mainWrap.classList.remove('is-lightbox-opening');
    }

    setScrollToTopOffset(0);

    if (sectionEl.dataset) {
      sectionEl.dataset.productInitialized = 'false';
    }
    sectionEl.__productCleanup = null;
  };
  }

  initAxiomProduct(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAxiomProduct(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-product-root]').forEach(function (sectionEl) {
      if (typeof sectionEl.__productCleanup === 'function') {
        sectionEl.__productCleanup();
      }
    });
  });
})();

